module.exports = __webpack_public_path__ + "img/Swiper.e02d4148.jpg";